import { IconButton, Stack, Typography } from '@mui/material';
import { Root } from './LeftSidebarHeader.styles';
import { Plus } from 'lucide-react';

interface LeftSidebarHeaderProps {
  children?: React.ReactNode;
  canCreate: boolean;
  title: string;
  onPlusClick: () => void;
  'data-testid'?: string;
}

const LeftSidebarHeader = ({
  children,
  canCreate,
  title,
  onPlusClick,
  'data-testid': testId,
}: LeftSidebarHeaderProps) => (
  <Root data-testid={testId}>
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Typography variant='h3' component='h3'>
        {title}
      </Typography>
      <div>
        {canCreate && (
          <IconButton color='primary' onClick={onPlusClick} data-testid='create-meeting-button'>
            <Plus strokeWidth={2.5} size={18} />
          </IconButton>
        )}
      </div>
    </Stack>
    {children}
  </Root>
);

export default LeftSidebarHeader;
